import React, { useEffect, useState } from "react";
import { doc, onSnapshot, collection, query, where, getDocs } from "firebase/firestore";
import { db, auth } from "./firebase";
import QRCode from "react-qr-code";

const IDCardPage = () => {
    const [teamData, setTeamData] = useState(null);
    const [teamId, setTeamId] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTeamData = async () => {
            const user = auth.currentUser;
            if (!user) {
                console.log("No user logged in");
                setLoading(false);
                return;
            }

            try {
                // Query Firestore for the document where email matches
                const teamsRef = collection(db, "teams");
                const q = query(teamsRef, where("email", "==", user.email));
                const querySnapshot = await getDocs(q);

                if (!querySnapshot.empty) {
                    const docSnap = querySnapshot.docs[0];
                    const docId = docSnap.id; // Get team document ID
                    setTeamId(docId);

                    // Listen for real-time updates on the document
                    const teamDocRef = doc(db, "teams", docId);
                    const unsubscribe = onSnapshot(teamDocRef, (docSnapshot) => {
                        if (docSnapshot.exists()) {
                            const data = docSnapshot.data();
                            console.log("Real-time update received:", data);
                            setTeamData(data);
                        }
                    });

                    return () => unsubscribe(); // Cleanup listener when unmounting
                } else {
                    console.log("No team found for this email");
                }
            } catch (error) {
                console.error("Error fetching document: ", error);
            } finally {
                setLoading(false);
            }
        };

        fetchTeamData();
    }, []);

    if (loading) {
        return <div className="flex justify-center items-center h-screen text-lg">Loading...</div>;
    }

    if (!teamData) {
        return <div className="flex justify-center items-center h-screen text-lg text-red-500">No team data found.</div>;
    }

    return (
        <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-blue-200 to-purple-300 p-6">
            <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md">
                <h2 className="text-2xl font-bold text-center text-blue-700 mb-4">Team Leader ID Card</h2>
                <div className="border-2 border-blue-500 rounded-lg p-4 relative overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-purple-500 opacity-10" />
                    <h3 className="text-xl font-semibold text-gray-800 text-center mb-2">
                        {teamData.teamLeaderSalutation} {teamData.teamLeaderName}
                    </h3>
                    <p className="text-gray-600 text-center">{teamData.email}</p>
                    <p className="text-gray-600 text-center mb-4">{teamData.contactNumber}</p>
                    <div className="flex justify-center items-center mb-4">
                        {teamId && <QRCode value={teamId} size={150} />}
                    </div>
                    <p className="text-center text-gray-700">Scan this QR code for attendance verification</p>
                    <p className={`text-center mt-4 text-lg font-bold ${teamData.teamLeaderAttendance ? "text-green-500" : "text-red-500"}`}>
                        Team Leader Attendance: {teamData.teamLeaderAttendance ? "Present" : "Absent"}
                    </p>
                    <h3 className="text-lg font-semibold text-gray-800 text-center mt-4">Team Members Attendance</h3>
                    <ul className="text-center">
                        {teamData.teamMembers && teamData.teamMembers.length > 0 ? (
                            teamData.teamMembers.map((member, index) => (
                                <li key={index} className={member.attendance ? "text-green-500" : "text-red-500"}>
                                    {member.name} - {member.attendance ? "Present" : "Absent"}
                                </li>
                            ))
                        ) : (
                            <p className="text-gray-600">No team members available</p>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default IDCardPage;
